import Rollbar from 'rollbar';
import { VueConstructor } from 'vue/types/umd';

export default {
  install: (Vue: VueConstructor, options: Rollbar.Configuration) => {
    Vue.prototype.$rollbar = new Rollbar(options);
  },
};
